module.exports = __webpack_public_path__ + "img/rzr-starter-mb.f7d2268.jpg";